import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, ButtonGroup, Card, CardBody, CardHeader, DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledDropdown } from 'reactstrap';
import Swal from 'sweetalert2';
import { deleteCertificateAPI, getSingleCertificateAPI } from '../../apiConfig/apiCall';
import dummyUserImage from '../../assets/images/users/user-dummy-img.jpg';
import { getCertificationList } from '../../slices/ManageCompliance/manageComplianceSlice';
import AddCertificateModal from './AddCertificateModal';
import CertificationPointsModal from './CertificationPointsModal';
import ProfileSelector from './ImageSetter/ProfileSelector';
import UploadCertificateModal from './UploadCertificateModal';
import BasicTable from '../ReactTable/BasicTable';

const ComplianceTable = ({ data, refreshClientList }) => {

    const dispatch = useDispatch();

    const API_IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL_2;

    const [filtering, setFiltering] = useState('');
    const [pageSize, setPageSize] = useState(10);

    // Upload User Profile Image Logic
    const [userProfileImgUploadModal, setUserProfileImgUploadModal] = useState(false);
    const [currentToggledUserProfileImgUrl, setCurrentToggledUserProfileImgUrl] = useState('');
    const [currentUserSsoIdForEditProfile, setCurrentUserSsoIdForEditProfile] = useState('');
    const toggleUserProfileImgUploadModal = (imagePath, SSO_ID) => {
        console.log(SSO_ID)
        setCurrentToggledUserProfileImgUrl(imagePath);
        setCurrentUserSsoIdForEditProfile(SSO_ID);
        setUserProfileImgUploadModal(!userProfileImgUploadModal);
    }

    console.log(data)

    const columns = [
        {
            header: "S.No",
            accessorKey: "id",
            cell: ({ row }) => (
                <span className="fw-semibold">{row.index + 1}</span>
            ),
            enableSorting: false,
        },
        {
            header: "Logo",
            accessorKey: "file",
            cell: ({ getValue, row }) => (
                <div className="profile-user position-relative d-inline-block">
                    <img src={`${API_IMAGE_URL}${getValue()}?t=${new Date().getTime()}`}
                        onError={(e) => { e.target.src = dummyUserImage; }}
                        className="rounded-circle avatar-xxs img-thumbnail user-profile-image material-shadow"
                        alt="user-profile" />
                    <div className="avatar-xs p-0 rounded-circle profile-photo-edit" onClick={() => toggleUserProfileImgUploadModal(API_IMAGE_URL+ getValue(), row.original.id)}>
                        <Input id="profile-img-file-input" type="file"
                            className="profile-img-file-input" />
                        <Label htmlFor="profile-img-file-input"
                            className="profile-photo-edit" style={{ height: '1.2rem', width: '1.2rem', left: '1.5rem', top: '.8rem' }}>
                            <span className="avatar-title rounded-circle bg-light text-body material-shadow">
                                <i className="ri-camera-fill"></i>
                            </span>
                        </Label>
                    </div>
                </div>
            ),
            enableSorting: false,
        },
        {
            header: "Certificate Type",
            accessorKey: "certificationType",
        },
        {
            header: "Certificate Version",
            accessorKey: "certificationVersion",
        },
        {
            header: "Status",
            accessorKey: "status",
            cell: ({ row }) => (
                <span
                    style={{
                        color: row.original.status === 'ACTIVE' ? 'green' : 'red',
                    }}
                >
                    {row.original.status}
                </span>
            ),
        },
        {
            header: "Entry Date",
            accessorKey: "entryDate",
        },
        {
            header: "Actions",
            accessorKey: "actions",
            cell: ({ row }) => (
                <div className="d-flex gap-2">

                    <div
                        onClick={() => handleDelete(row.original.id)}
                        className="text-danger bg-danger-subtle fs-11 cursor-pointer"
                        style={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="bx bxs-trash-alt"></i>
                    </div>

                    <div
                        onClick={() => handleViewCertificationPoints(row.original.id)}
                        className="text-info bg-info-subtle fs-11 cursor-pointer"
                        style={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="ri-list-unordered"></i>
                    </div>
                </div>
            ),
            enableSorting: false,
        },
    ];

    // Add Certificate Logic
    const [addCertificateModal, setAddCertificateModal] = useState(false);
    const [uploadCertificateModal, setUploadCertificateModal] = useState(false);

    const toggleAddCertificateModal = () => setAddCertificateModal(!addCertificateModal);
    const toggleUploadCertificateModal = () => setUploadCertificateModal(!uploadCertificateModal);


    // Delete Certificate Logic
    const handleDelete = (id) => {
        Swal.fire({
            width: '20rem',
            padding: '0 0 1rem 0',
            title: "Are you sure?",
            text: `You won't be able to revert this!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteCertificateAPI(id)
                    .then(response => {
                        Swal.fire({
                            title: "Deleted!",
                            text: response.data,
                            icon: "success",
                            width: '20rem',
                            padding: '0 0 1rem 0',
                        });
                        dispatch(getCertificationList());
                    })
                    .catch(error => {
                        Swal.fire({
                            title: "Error!",
                            text: error,
                            icon: "error",
                            width: '20rem',
                            padding: '0 0 1rem 0',
                        });
                    });
            }
        });
    };


    // Cerification Points Modal
    const [certificationType, setCertificationType] = useState('');
    const [certificationVersion, setCertificationVersion] = useState('');
    const [certificationPoints, setCertificationPoints] = useState('');

    const [certificationPointsModal, setCertificationPointsModal] = useState(false);
    const toggleCertificationPointsModal = () => setCertificationPointsModal(!certificationPointsModal);


    const [cvId, setCvId] = useState();

    const handleViewCertificationPoints = async (certificationID) => {
        setCertificationPointsModal(true);

        const apiResponse = await getSingleCertificateAPI(certificationID);
        if (apiResponse.status === 200) {
            setCertificationType(apiResponse.data.certificationType);
            setCertificationVersion(apiResponse.data.certificationVersion);
            setCertificationPoints(apiResponse.data.certificationVersionPoints)
            setCvId(apiResponse.data.id);
        }
    }

    return (
        <>

            <Card>
                <CardHeader className="border-0 py-1">
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <div className="d-flex align-items-center">
                                <h5 className="card-title mb-0">Certification List</h5>
                                <ButtonGroup className="material-shadow ms-2">
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            tag="button"
                                            className="btn p-1 btn-sm btn-light material-shadow-none"
                                            style={{
                                                fontSize: '.7rem',
                                            }}
                                        >
                                            {pageSize} <i className="mdi mdi-chevron-down"></i>
                                        </DropdownToggle>
                                        <DropdownMenu style={{ minWidth: '100%' }}>
                                            {[10, 20, 50, 100].map((size) => (
                                                <DropdownItem
                                                    key={size}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '0.2rem',
                                                        fontSize: '.7rem',
                                                    }}
                                                    onClick={() => setPageSize(size)}
                                                >
                                                    {size}
                                                </DropdownItem>
                                            ))}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </ButtonGroup>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex">
                                <input
                                    className="form-control me-2"
                                    type="text"
                                    placeholder="Search..."
                                    value={filtering}
                                    onChange={(e) => setFiltering(e.target.value)}
                                    style={{
                                        height: '28px',
                                        fontSize: '.7rem',
                                        borderRadius: '.2rem',
                                    }}
                                />
                                <Button
                                    type="button"
                                    className="btn-sm btn-success me-2"
                                    onClick={toggleAddCertificateModal}
                                    style={{
                                        width: '100%',
                                        height: '28px',
                                        fontSize: '.7rem',
                                        borderRadius: '.2rem',
                                    }}
                                >
                                    <i className="ri-add-line align-bottom me-1"></i>
                                    Add Certificate
                                </Button>
                                <Button
                                    type="button"
                                    className="btn-sm btn-success"
                                    onClick={toggleUploadCertificateModal}
                                    style={{
                                        width: '100%',
                                        height: '28px',
                                        fontSize: '.7rem',
                                        borderRadius: '.2rem',
                                    }}
                                >
                                    <i className="ri-upload-line align-bottom me-1"></i>
                                    Upload Certificate
                                </Button>
                            </div>
                        </div>
                    </div>
                </CardHeader>


                <CardBody className="border border-dashed border-end-0 border-start-0">
                    <BasicTable
                        columns={columns}
                        data={data}
                        customPageSize={pageSize}
                        filtering={filtering}
                        setFiltering={setFiltering}
                    />
                </CardBody>
            </Card>

            {/* <BasicTable
                columns={columns}
                data={data}
                customPageSize={10}
                addCertificateHandler={toggleAddCertificateModal}
                uploadCertificateHandler={toggleUploadCertificateModal}
            /> */}

            {/* Add Certificate Modal */}
            <AddCertificateModal
                addCertificateModal={addCertificateModal}
                setAddCertificateModal={setAddCertificateModal}
                toggleAddCertificateModal={toggleAddCertificateModal}
            />

            {/* Upload Certificate Modal */}
            <UploadCertificateModal
                uploadCertificateModal={uploadCertificateModal}
                setUploadCertificateModal={setUploadCertificateModal}
                toggleUploadCertificateModal={toggleUploadCertificateModal}
            />

            {/* Upload Logo Image */}
            <Modal isOpen={userProfileImgUploadModal} toggle={toggleUserProfileImgUploadModal}>
                <ModalHeader toggle={toggleUserProfileImgUploadModal}>Upload Logo Image</ModalHeader>
                <ModalBody>
                    <ProfileSelector image={currentToggledUserProfileImgUrl} ssoId={currentUserSsoIdForEditProfile} modalHandler={toggleUserProfileImgUploadModal} refreshClientList={refreshClientList} />
                </ModalBody>
            </Modal>

            {/* Cerification Points Modal */}
            <CertificationPointsModal
                certificationPointsModal={certificationPointsModal}
                toggleCertificationPointsModal={toggleCertificationPointsModal}
                certificationType={certificationType}
                certificationVersion={certificationVersion}
                certificationPoints={certificationPoints}
                setCertificationPoints={setCertificationPoints}
                cvId={cvId}
            />

        </>
    );
};

export default ComplianceTable;